/**
 * Dashboard formatting. Arabic dates use the Gregorian calendar with Latin
 * digits (the plain 'ar-SA' locale switches to Hijri and Arabic-Indic
 * numerals, which mixed badly with the Latin digits used everywhere else).
 */

const locale = (isRTL: boolean) => (isRTL ? 'ar-SA-u-ca-gregory-nu-latn' : 'en-GB');

const toDate = (value?: string | Date | null): Date | null => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

/** "السبت، 26 سبتمبر 2026" / "Saturday, 26 September 2026". */
export const formatLongDate = (value: string | Date, isRTL: boolean): string => {
  const d = toDate(value);
  if (!d) return '';
  return d.toLocaleDateString(locale(isRTL), {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

/** "17 سبتمبر" / "17 Sep". */
export const formatShortDate = (value: string | undefined | null, isRTL: boolean): string => {
  const d = toDate(value);
  if (!d) return '';
  return d.toLocaleDateString(locale(isRTL), {
    day: 'numeric',
    month: isRTL ? 'long' : 'short',
  });
};

/** Integer with Latin digits and grouping, in both languages. */
export const formatCount = (value: number | null | undefined): string =>
  Math.round(value ?? 0).toLocaleString('en-US');

/** 0–100, rounded and clamped. */
export const clampPercent = (value: number | null | undefined): number =>
  Math.max(0, Math.min(100, Math.round(value ?? 0)));
